import { Component, inject, OnInit, signal, WritableSignal, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
// import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../services/api/user/user.service";
import { MultiSelectModule } from "@openng/optimus-ui/multiselect";
import { ButtonComponent } from "../button/button.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-send-email-form",
  standalone: true,
  imports: [ReactiveFormsModule, MultiSelectModule, ButtonComponent, TranslateModule],
  templateUrl: "./send-email-form.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./send-email-form.component.scss",
})
export class SendEmailFormComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    emailList: new FormControl([], Validators.required),
  });
  public users: WritableSignal<any[]> = signal([]);
  public translate = inject(TranslateService);

  private userService = inject(UserService);
  // private config = inject(DynamicDialogConfig);
  // private ref = inject(DynamicDialogRef);

  public ngOnInit() {
    this.userService.getUsers().subscribe((users) => {
      this.users.set(users);
    });
  }
  /**
   * Sends an email to the selected recipients in the email list.
   * Retrieves the email addresses from the form's emailList control.
   */
  public sendEmail() {
    // const emailList = this.form.get("emailList")?.value;
  }
}
